/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "components/common_components/Header";
import MenuItem from "components/Menu/MenuItem";
import { Tenant } from "utils/tenants";
import { hasSettingsPermission } from "utils/session";

const getOptions = (user) =>
    [
        { index: 0, label: "Users", path: "/settings/users", icon: "users" },
        { index: 1, label: "Groups/Permissions", path: "/settings/groups-permissions", icon: "groups" },
        { index: 2, label: "Business Hours", path: "/settings/business-hours", icon: "business-hours" },
        Tenant.getFeatures().modules.enabled && { index: 3, label: "Case Types", path: "/settings/types", icon: "types" },
        Tenant.getFeatures().modules.enabled && { index: 4, label: "Case Status", path: "/settings/status", icon: "status" },
        Tenant.getFeatures().modules.enabled && { index: 5, label: "Modules", path: "/settings/modules", icon: "modules" },
        Tenant.getFeatures().modules.enabled && { index: 6, label: "Contact Types", path: "/settings/contact-types", icon: "contact-type" },
        Tenant.getFeatures().modules.enabled && { index: 7, label: "File Locations", path: "/settings/file-locations", icon: "locations" },
        Tenant.getFeatures().modules.enabled && { index: 8, label: "Workflows", path: "/settings/flows", icon: "workflow" },
        Tenant.getFeatures().pos.enabled && { index: 9, label: "POS Categories", path: "/settings/pos/categories", icon: "pos" },
        Tenant.getFeatures().invoicing.enabled && {
            index: 10,
            label: "Documents Issuer",
            path: "/settings/documents-issuer",
            icon: "personal-info",
        },
        Tenant.getFeatures().invoicing.enabled && { index: 11, label: "Services", path: "/settings/services", icon: "list" },
        Tenant.getFeatures().chainOfCustody.enabled && {
            index: 12,
            label: "Chain of Custody",
            path: "/settings/chain-of-custody",
            icon: "folder",
        },
        Tenant.getFeatures().forms.enabled && {
            index: 13,
            label: "Forms",
            path: "/settings/forms",
            icon: "form",
            permissionKey: "settings.forms.access",
        },
        { index: 14, label: "System", path: "/settings/system-parameters", icon: "settings" },
    ].filter((option) => Boolean(option) && hasSettingsPermission(user, option.permissionKey));

function Settings({ children, history }) {
    const { user } = useSelector((state) => state.Login);
    const options = getOptions(user);
    const [selectedOption, setSelectedOption] = useState(options[0]);

    useEffect(() => {
        const mainContainer = document.getElementsByTagName("main")[0];
        if (mainContainer) mainContainer.style.padding = "0";

        return () => {
            if (mainContainer) mainContainer.style.padding = "2rem";
        };
    }, []);

    useEffect(() => {
        const newSelectedOption = options.find((o) => history.location.pathname.startsWith(o.path));
        if (newSelectedOption) {
            setSelectedOption(newSelectedOption);
        }
    }, [history.location.pathname]);

    return (
        <div className="settings">
            <div className="nav">
                <div className="nav__header nav-inner">
                    <Header title="Settings" />
                </div>
                <div className="nav__body">
                    <div className="nav-list">
                        {options.map((option) => (
                            <MenuItem
                                key={option.index}
                                id={option.index}
                                label={option.label}
                                icon={option.icon}
                                selected={option.index === selectedOption.index}
                                path={option.path}
                                onClick={() => setSelectedOption(option)}
                            />
                        ))}
                    </div>
                </div>
            </div>
            <div className="content">{children}</div>
        </div>
    );
}

export default withRouter(Settings);
